var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgGainLike = function SvgGainLike(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "gainLike_svg__\\xE8\\x8E\\xB7\\xE8\\xB5\\x9E\\xE6\\x95\\xB0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gainLike_svg__\\xE5\\xBD\\xA2\\xE7\\x8A\\xB6\\xE7\\xBB\\x93\\xE5\\x90\\x88",
    d: "M7.32323 1.28434L5.01162 4.19356C4.94745 4.27432 4.85684 4.31871 4.76388 4.31871H3.12338C2.22065 4.31871 1.5 5.06916 1.5 5.98177L1.5 12.9576C1.5 13.2572 1.74285 13.5 2.04241 13.5H11.5531C12.5963 13.5 13.4764 12.7193 13.639 11.6694L14.4799 6.24256C14.5534 5.76795 14.4231 5.28298 14.1209 4.91349L14.013 4.79404C13.7118 4.4915 13.3045 4.31859 12.8762 4.31871L10.5711 4.31814L10.9267 3.41434C11.3417 2.46477 10.9781 1.31643 10.07 0.791132C9.15555 0.262044 8.00727 0.47028 7.32323 1.28434Z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    id: "gainLike_svg__\\xE5\\xBD\\xA2\\xE7\\x8A\\xB6\\xE7\\xBB\\x93\\xE5\\x90\\x88_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45362 3.6377L5.01189 4.19363C4.94771 4.2744 4.85711 4.31879 4.76414 4.31879H4.19629L4.22788 8.66788L4.23553 8.74447C4.28324 8.99424 4.54759 9.18427 4.86446 9.18201C5.21301 9.17953 5.49311 8.94532 5.49009 8.65889L5.45362 3.6377Z",
    fill: "url(#".concat(_id2, ")")
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -5,
    y1: 7,
    x2: 8,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59ADFF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3377FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 6.97649,
    y1: 10.4061,
    x2: 2.39509,
    y2: 8.81107,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.639724
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
export default SvgGainLike;